// UK VAT follows the invoicing address. Mirrors sow_commission.is_uk_country.
const UK_NAMES = new Set([
  "uk", "u k", "gb", "gbr", "united kingdom", "great britain", "britain", "england", "scotland", "wales",
  "northern ireland", "united kingdom of great britain and northern ireland",
]);

export function isUkCountry(country) {
  return String(country || "")
    .split(/[,/()]/)
    .some((part) => UK_NAMES.has(part.toLowerCase().replace(/[^a-z ]/g, " ").replace(/\s+/g, " ").trim()));
}

// "Yes" / "No" once a country is given, null while it is blank.
export function vatFromCountry(country) {
  if (!String(country || "").trim()) return null;
  return isUkCountry(country) ? "Yes" : "No";
}
